(function () {
  'use strict';

  function mountHiChanVideo() {
    const figure =
      document.getElementById('hichan-reaction-video');

    if (!figure) {
      return;
    }

    const mount =
      figure.querySelector(
        '.hichan-reaction-video__mount'
      );

    if (!mount) {
      return;
    }

    if (
      mount.getAttribute('data-player-mounted') ===
      'true'
    ) {
      return;
    }

    mount.setAttribute(
      'data-player-mounted',
      'true'
    );


    /* =====================================================
       ICONS
       ===================================================== */

    const icons = {
      play:
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M8 5v14l11-7z"></path>' +
        '</svg>',

      pause:
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M6 5h4v14H6zm8 0h4v14h-4z"></path>' +
        '</svg>',

      volume:
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M5 9v6h4l5 4V5L9 9H5zm11.5 3a4.5 4.5 0 0 0-1.5-3.35v6.7A4.5 4.5 0 0 0 16.5 12z"></path>' +
        '</svg>',

      muted:
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M5 9v6h4l5 4V5L9 9H5zm11.6 3 2.7 2.7 1.4-1.4L18 10.6l2.7-2.7-1.4-1.4-2.7 2.7-2.7-2.7-1.4 1.4 2.7 2.7-2.7 2.7 1.4 1.4 2.7-2.7z"></path>' +
        '</svg>',

      fullscreen:
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zm-3-12v2h3v3h2V5h-5z"></path>' +
        '</svg>',

      exitFullscreen:
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"></path>' +
        '</svg>'
    };


    /* =====================================================
       PLAYER
       ===================================================== */

    const player =
      document.createElement('div');

    player.className =
      'hichan-video-player';

    player.setAttribute(
      'tabindex',
      '0'
    );


    /* =====================================================
       VIDEO
       ===================================================== */

    const video =
      document.createElement('video');


    /*
      The tiny media-fragment offset helps Safari/iPhone
      decode an actual image instead of leaving the
      video surface black before playback.
    */

    video.src =
      'https://cdn.shopify.com/videos/c/o/v/f62f2814d9314ce0a8991272519c1bae.mp4#t=0.05';


    /*
      Ask the browser to preload actual media data,
      not only metadata.

      Safari may still decide how aggressively it wants
      to preload, but this gives it the strongest hint.
    */

    video.preload =
      'auto';

    video.setAttribute(
      'preload',
      'auto'
    );


    video.controls =
      false;

    video.playsInline =
      true;

    video.setAttribute(
      'playsinline',
      ''
    );

    video.setAttribute(
      'webkit-playsinline',
      ''
    );


    /*
      These don't provide DRM.
      They suppress browser UI features where supported.
    */

    video.setAttribute(
      'controlslist',
      'nodownload noplaybackrate'
    );

    video.setAttribute(
      'disablepictureinpicture',
      ''
    );

    video.setAttribute(
      'disableremoteplayback',
      ''
    );

    video.disablePictureInPicture =
      true;


    /* =====================================================
       PRIME FIRST FRAME
       =====================================================

       iPhone Safari can leave a paused video black until
       it has decoded a real frame.

       As soon as metadata becomes available, we seek a
       tiny fraction into the video.

       The viewer still experiences the video as starting
       from the beginning.
       ===================================================== */

    let firstFramePrimed =
      false;


    function primeFirstFrame() {
      if (
        firstFramePrimed ||
        !Number.isFinite(video.duration) ||
        video.duration <= 0
      ) {
        return;
      }


      firstFramePrimed =
        true;


      try {
        video.currentTime =
          Math.min(
            0.05,
            video.duration
          );
      } catch (error) {
        /*
          Safari may temporarily reject the seek.
          loadeddata below gives us a second chance.
        */
      }
    }


    video.addEventListener(
      'loadedmetadata',
      primeFirstFrame,
      {
        once: true
      }
    );


    /*
      Second Safari pass.

      Some versions expose metadata before they are ready
      to render the requested frame.
    */

    video.addEventListener(
      'loadeddata',
      function () {
        if (
          video.paused &&
          video.currentTime < 0.1
        ) {
          try {
            video.currentTime =
              0.05;
          } catch (error) {}
        }
      },
      {
        once: true
      }
    );


    /*
      Once Safari has successfully seeked to the tiny
      offset, the decoded frame should remain visible.
    */

    video.addEventListener(
      'seeked',
      function () {
        if (
          video.paused &&
          video.currentTime < 0.12
        ) {
          firstFramePrimed =
            true;
        }
      }
    );


    /*
      Remove the ordinary browser context menu
      from the video surface.
    */

    video.addEventListener(
      'contextmenu',
      function (event) {
        event.preventDefault();
      }
    );


    /* =====================================================
       CONTROLS
       ===================================================== */

    const controls =
      document.createElement('div');

    controls.className =
      'hichan-video-controls';


    /* PLAY */

    const playButton =
      document.createElement('button');

    playButton.type =
      'button';

    playButton.className =
      'hichan-video-button';

    playButton.setAttribute(
      'aria-label',
      'Play video'
    );

    playButton.setAttribute(
      'title',
      'Play'
    );

    playButton.innerHTML =
      icons.play;


    /* PROGRESS */

    const progress =
      document.createElement('input');

    progress.type =
      'range';

    progress.className =
      'hichan-video-progress';

    progress.min =
      '0';

    progress.max =
      '1000';

    progress.step =
      '1';

    progress.value =
      '0';

    progress.setAttribute(
      'aria-label',
      'Video progress'
    );


    /* TIME */

    const time =
      document.createElement('span');

    time.className =
      'hichan-video-time';

    time.textContent =
      '0:00 / 0:00';


    /* MUTE */

    const muteButton =
      document.createElement('button');

    muteButton.type =
      'button';

    muteButton.className =
      'hichan-video-button';

    muteButton.setAttribute(
      'aria-label',
      'Mute video'
    );

    muteButton.setAttribute(
      'title',
      'Mute'
    );

    muteButton.innerHTML =
      icons.volume;


    /* FULLSCREEN */

    const fullscreenButton =
      document.createElement('button');

    fullscreenButton.type =
      'button';

    fullscreenButton.className =
      'hichan-video-button';

    fullscreenButton.setAttribute(
      'aria-label',
      'Enter fullscreen'
    );

    fullscreenButton.setAttribute(
      'title',
      'Fullscreen'
    );

    fullscreenButton.innerHTML =
      icons.fullscreen;


    /* =====================================================
       BUILD
       ===================================================== */

    controls.appendChild(
      playButton
    );

    controls.appendChild(
      progress
    );

    controls.appendChild(
      time
    );

    controls.appendChild(
      muteButton
    );

    controls.appendChild(
      fullscreenButton
    );

    player.appendChild(
      video
    );

    player.appendChild(
      controls
    );

    mount.appendChild(
      player
    );


    /*
      Explicitly ask the browser to begin loading now that
      the element has been inserted into the document.
    */

    try {
      video.load();
    } catch (error) {}


    /* =====================================================
       HELPERS
       ===================================================== */

    function formatTime(seconds) {
      if (
        !Number.isFinite(seconds)
      ) {
        return '0:00';
      }

      const minutes =
        Math.floor(
          seconds / 60
        );

      const remaining =
        Math.floor(
          seconds % 60
        );

      return (
        minutes +
        ':' +
        String(remaining).padStart(
          2,
          '0'
        )
      );
    }


    function updateProgress() {
      if (
        !Number.isFinite(
          video.duration
        ) ||
        video.duration <= 0
      ) {
        progress.value = '0';

        time.textContent =
          formatTime(
            video.currentTime
          ) +
          ' / 0:00';

        return;
      }

      progress.value =
        String(
          Math.round(
            (
              video.currentTime /
              video.duration
            ) *
            1000
          )
        );

      time.textContent =
        formatTime(
          video.currentTime
        ) +
        ' / ' +
        formatTime(
          video.duration
        );
    }


    function updatePlayButton() {
      if (
        video.paused ||
        video.ended
      ) {
        playButton.innerHTML =
          icons.play;

        playButton.setAttribute(
          'aria-label',
          'Play video'
        );

        playButton.setAttribute(
          'title',
          'Play'
        );
      } else {
        playButton.innerHTML =
          icons.pause;

        playButton.setAttribute(
          'aria-label',
          'Pause video'
        );

        playButton.setAttribute(
          'title',
          'Pause'
        );
      }
    }


    function updateMuteButton() {
      if (
        video.muted ||
        video.volume === 0
      ) {
        muteButton.innerHTML =
          icons.muted;

        muteButton.setAttribute(
          'aria-label',
          'Unmute video'
        );

        muteButton.setAttribute(
          'title',
          'Unmute'
        );
      } else {
        muteButton.innerHTML =
          icons.volume;

        muteButton.setAttribute(
          'aria-label',
          'Mute video'
        );

        muteButton.setAttribute(
          'title',
          'Mute'
        );
      }
    }


    function fullscreenActive() {
      return (
        document.fullscreenElement ===
          player ||
        document.webkitFullscreenElement ===
          player
      );
    }


    function updateFullscreenButton() {
      if (
        fullscreenActive()
      ) {
        fullscreenButton.innerHTML =
          icons.exitFullscreen;

        fullscreenButton.setAttribute(
          'aria-label',
          'Exit fullscreen'
        );

        fullscreenButton.setAttribute(
          'title',
          'Exit fullscreen'
        );
      } else {
        fullscreenButton.innerHTML =
          icons.fullscreen;

        fullscreenButton.setAttribute(
          'aria-label',
          'Enter fullscreen'
        );

        fullscreenButton.setAttribute(
          'title',
          'Fullscreen'
        );
      }
    }


    function togglePlayback() {
      if (
        video.paused ||
        video.ended
      ) {
        /*
          If the frame-prime trick placed the video at
          0.05 seconds, playback simply continues from
          there. The difference is imperceptible.
        */

        const playPromise =
          video.play();

        if (
          playPromise &&
          typeof playPromise.catch ===
            'function'
        ) {
          playPromise.catch(
            function () {}
          );
        }
      } else {
        video.pause();
      }
    }


    /* =====================================================
       FULLSCREEN
       ===================================================== */

    function toggleFullscreen() {
      /*
        Exit fullscreen first.
      */

      if (
        document.fullscreenElement
      ) {
        const exitPromise =
          document.exitFullscreen();

        if (
          exitPromise &&
          typeof exitPromise.catch ===
            'function'
        ) {
          exitPromise.catch(
            function () {}
          );
        }

        return;
      }


      if (
        document.webkitFullscreenElement &&
        document.webkitExitFullscreen
      ) {
        document.webkitExitFullscreen();

        return;
      }


      /*
        Chrome, Edge, Firefox, modern Safari.
      */

      if (
        player.requestFullscreen
      ) {
        const request =
          player.requestFullscreen();

        if (
          request &&
          typeof request.catch ===
            'function'
        ) {
          request.catch(
            function () {}
          );
        }

        return;
      }


      /*
        Older desktop Safari.
      */

      if (
        player.webkitRequestFullscreen
      ) {
        player.webkitRequestFullscreen();

        return;
      }


      /*
        iPhone Safari fallback.
      */

      if (
        video.webkitEnterFullscreen
      ) {
        video.webkitEnterFullscreen();
      }
    }


    /* =====================================================
       EVENTS
       ===================================================== */

    playButton.addEventListener(
      'click',
      togglePlayback
    );


    video.addEventListener(
      'click',
      togglePlayback
    );


    muteButton.addEventListener(
      'click',
      function () {
        video.muted =
          !video.muted;

        updateMuteButton();
      }
    );


    fullscreenButton.addEventListener(
      'click',
      toggleFullscreen
    );


    progress.addEventListener(
      'input',
      function () {
        if (
          !Number.isFinite(
            video.duration
          ) ||
          video.duration <= 0
        ) {
          return;
        }

        video.currentTime =
          (
            Number(
              progress.value
            ) /
            1000
          ) *
          video.duration;
      }
    );


    /*
      Metadata also primes the first frame.
    */

    video.addEventListener(
      'loadedmetadata',
      function () {
        updateProgress();
        primeFirstFrame();
      }
    );


    video.addEventListener(
      'durationchange',
      updateProgress
    );


    video.addEventListener(
      'timeupdate',
      updateProgress
    );


    video.addEventListener(
      'play',
      updatePlayButton
    );


    video.addEventListener(
      'pause',
      updatePlayButton
    );


    video.addEventListener(
      'ended',
      updatePlayButton
    );


    video.addEventListener(
      'volumechange',
      updateMuteButton
    );


    document.addEventListener(
      'fullscreenchange',
      updateFullscreenButton
    );


    document.addEventListener(
      'webkitfullscreenchange',
      updateFullscreenButton
    );


    /* =====================================================
       KEYBOARD
       ===================================================== */

    player.addEventListener(
      'keydown',
      function (event) {
        /*
          Leave the range input's own keyboard
          controls alone.
        */

        if (
          event.target === progress
        ) {
          return;
        }

        if (
          event.code === 'Space'
        ) {
          event.preventDefault();

          togglePlayback();
        }

        if (
          event.key &&
          event.key.toLowerCase() ===
            'm'
        ) {
          video.muted =
            !video.muted;
        }

        if (
          event.key &&
          event.key.toLowerCase() ===
            'f'
        ) {
          toggleFullscreen();
        }
      }
    );


    /* =====================================================
       INITIAL STATE
       ===================================================== */

    updateProgress();
    updatePlayButton();
    updateMuteButton();
    updateFullscreenButton();
  }


  /* =======================================================
     LOAD
     ======================================================= */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      mountHiChanVideo,
      {
        once: true
      }
    );
  } else {
    mountHiChanVideo();
  }


  /*
    Keeps it working in the Shopify theme editor too.
  */

  document.addEventListener(
    'shopify:section:load',
    mountHiChanVideo
  );
})();